// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedPromoCode: Object,
};

const DeletePromotionalCode = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedPromoCode,
  } = props;

  const deleteSelectedPromo = () => {
    submit(selectedPromoCode.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedPromo} type="danger">Deactivate</SpButton>,
      ]}
      title="Deactivate Promotional Code"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to deactivate this Promotional Code?</h6>
        <SpH5 className="pb-3">
          <div>{selectedPromoCode.code}</div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeletePromotionalCode;
